var f = "\\ud800-\\udfff", l = "\\u0300-\\u036f", C = "\\ufe20-\\ufe2f", O = "\\u20d0-\\u20ff", L = l + C + O, d = "\\u2700-\\u27bf", o = "a-z\\xdf-\\xf6\\xf8-\\xff", j = "\\xac\\xb1\\xd7\\xf7", D = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", S = "\\u2000-\\u206f", U = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", n = "A-Z\\xc0-\\xd6\\xd8-\\xde", v = "\\ufe0e\\ufe0f", t = j + D + S + U, x = "['’]", u = "[" + t + "]", w = "[" + L + "]", i = "\\d+", A = "[" + d + "]", g = "[" + o + "]", p = "[^" + f + t + i + d + o + n + "]", h = "\\ud83c[\\udffb-\\udfff]", k = "(?:" + w + "|" + h + ")", E = "[^" + f + "]", b = "(?:\\ud83c[\\udde6-\\uddff]){2}", R = "[\\ud800-\\udbff][\\udc00-\\udfff]", r = "[" + n + "]", z = "\\u200d", s = "(?:" + g + "|" + p + ")", N = "(?:" + r + "|" + p + ")", e = "(?:" + x + "(?:d|ll|m|re|s|t|ve))?", a = "(?:" + x + "(?:D|LL|M|RE|S|T|VE))?", c = k + "?", m = "[" + v + "]?", T = "(?:" + z + "(?:" + [E, b, R].join("|") + ")" + m + c + ")*", V = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", W = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Z = m + c + T, B = "(?:" + [A, b, R].join("|") + ")" + Z, H = RegExp([
  r + "?" + g + "+" + e + "(?=" + [u, r, "$"].join("|") + ")",
  N + "+" + a + "(?=" + [u, r + s, "$"].join("|") + ")",
  r + "?" + s + "+" + e,
  r + "+" + a,
  W,
  V,
  i,
  B
].join("|"), "g");
function J(M) {
  return M.match(H) || [];
}
export {
  J as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_unicodeWords.js
// module id = 1558
// module chunks = 67